import { Link } from "react-router-dom";
import { getAvatarProfilePath, getUserProfilePath } from "../../utils/profilePaths";
import AvatarWithTrophy from "./AvatarWithTrophy";

/**
 * Clickable avatar — routes to /fan/:userId or /creator/:handle.
 */
export default function ProfileAvatarLink({
  user,
  userId,
  isCreator,
  handle,
  src,
  alt = "",
  className = "",
  imgClassName = "",
  imgStyle,
  size,
  pinnedTrophy,
  children,
  onClick,
}) {
  const profileUser = user || {
    uid: userId,
    isCreator,
    handle,
  };

  const to = user?.uid || user?.id
    ? getUserProfilePath(user)
    : getAvatarProfilePath(profileUser);

  const avatar = children || (
    <AvatarWithTrophy
      src={src}
      alt={alt}
      name={alt}
      imgClassName={imgClassName}
      imgStyle={imgStyle}
      size={size}
      pinnedTrophy={pinnedTrophy ?? user?.pinnedTrophy}
    />
  );

  if (!to) {
    return <span className={className}>{avatar}</span>;
  }

  return (
    <Link
      to={to}
      className={className}
      onClick={onClick}
      aria-label={alt ? `View ${alt}'s profile` : "View profile"}
    >
      {avatar}
    </Link>
  );
}
